import React from "react";
import { Lock, ShieldCheck, KeyRound, FileCheck, Eye, ServerCog } from "lucide-react";

const ITEMS = [
    { icon: Lock, h: "Encryption everywhere", p: "TLS 1.2+ in transit, AES-256 at rest, customer-managed keys on Enterprise." },
    { icon: ShieldCheck, h: "SOC 2 in progress", p: "Controls and audit logging modelled on SOC 2 Type II; annual external attestation underway." },
    { icon: KeyRound, h: "RBAC + SSO", p: "Role-based access control with audit trail; SAML SSO and SCIM on Enterprise." },
    { icon: FileCheck, h: "GDPR / CCPA aligned", p: "Data subject rights workflow, DPA available, data residency choices for paid tiers." },
    { icon: Eye, h: "Audit logging", p: "Every read, write, and admin action logged; exportable to your SIEM on Enterprise." },
    { icon: ServerCog, h: "99.9% uptime target", p: "Multi-region failover, monitored 24×7 by the team that builds the product." },
];

export const SecurityBadges = () => {
    return (
        <section className="section" data-testid="security-badges">
            <div className="container">
                <div className="section-head">
                    <span className="eyebrow">Security & compliance</span>
                    <h2 className="h2" style={{ marginTop: 18 }}>Built for operators who answer to auditors</h2>
                    <p>Security and compliance are table stakes for businesses you trust with your sales, money, and people.</p>
                </div>
                <div className="security-grid">
                    {ITEMS.map((it) => (
                        <div key={it.h} className="security-card" data-testid={`security-${it.h.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}>
                            <span className="icon-square"><it.icon size={20} /></span>
                            <h3 className="h3" style={{ fontSize: "1.05rem", marginTop: 14 }}>{it.h}</h3>
                            <p className="muted" style={{ margin: "8px 0 0 0", fontSize: "0.92rem" }}>{it.p}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SecurityBadges;
